import React from 'react';

/**
 * Live rooms + Nova Spaces tab content for Fertility Community demo.
 * Markup matches FertilityConnectDemo in WomenLikeMe.js; styles from WomenLikeMe.fertility.css
 * (scoped under .demo-product-input-scope .fec-connect-root).
 */
function DiscoverHeader({ eyebrow, title, sub, onSeeAll }) {
  return (
    <div className="fec-discover-header">
      <div className="fec-discover-header__left">
        <div className="fec-discover-eyebrow">{eyebrow}</div>
        <h2 className="fec-discover-title">{title}</h2>
        <p className="fec-discover-sub">{sub}</p>
      </div>
      <button type="button" className="fec-discover-see-all" onClick={onSeeAll}>
        See all →
      </button>
    </div>
  );
}

export function FertilityCommunityLiveTab({ navigate }) {
  const go = () => navigate('/signup');

  return (
    <div className="fec-connect-root chapter-fertility">
      <div className="fec-connect-discover">
        <section className="fec-connect-section fec-connect-section--discover fec-live-rooms-merged">
          <DiscoverHeader
            eyebrow="Nova Live Rooms"
            title="Support happening right now"
            sub="Open any time, expert-led sessions, and local rooms — all in one place."
            onSeeAll={go}
          />
          <div className="fec-live-rooms-grid">
            <div className="fec-live-rooms-grid__col">
              <div className="fec-live-rooms-grid__head">
                <div className="fec-live-rooms-grid__title">Open 24/7 — drop in any time</div>
                <div className="fec-live-rooms-grid__meta">
                  These rooms never close. Day or night, mid-spiral, post-scan.
                </div>
              </div>
              <div className="fec-discover-rooms">
                <div className="fec-room-row">
                  <div className="fec-room-row__left">
                    <div className="fec-room-emoji-box" aria-hidden>
                      💉
                    </div>
                    <div>
                      <div className="fec-room-card__title">Stims support</div>
                      <div className="fec-room-card__sub">Monitoring results · OHSS watch · injection timing</div>
                    </div>
                  </div>
                  <div className="fec-room-row__right">
                    <span className="fec-count-text">
                      <span className="fec-count-dot" aria-hidden="true" />
                      7 in room
                    </span>
                    <button type="button" className="fec-join-now" onClick={go}>
                      Join now
                    </button>
                  </div>
                </div>
                <div className="fec-room-row">
                  <div className="fec-room-row__left">
                    <div className="fec-room-emoji-box" aria-hidden>
                      ⏳
                    </div>
                    <div>
                      <div className="fec-room-card__title">Two-week wait</div>
                      <div className="fec-room-card__sub">Symptom spirals · testing day · the wait</div>
                    </div>
                  </div>
                  <div className="fec-room-row__right">
                    <span className="fec-count-text">
                      <span className="fec-count-dot" aria-hidden="true" />
                      8 in room
                    </span>
                    <button type="button" className="fec-join-now" onClick={go}>
                      Join now
                    </button>
                  </div>
                </div>
                <div className="fec-room-row">
                  <div className="fec-room-row__left">
                    <div className="fec-room-emoji-box" aria-hidden>
                      💔
                    </div>
                    <div>
                      <div className="fec-room-card__title">After a loss</div>
                      <div className="fec-room-card__sub">Processing a failed cycle or negative beta — no agenda</div>
                    </div>
                  </div>
                  <div className="fec-room-row__right">
                    <span className="fec-count-text">
                      <span className="fec-count-dot" aria-hidden="true" />
                      4 in room
                    </span>
                    <button type="button" className="fec-join-now" onClick={go}>
                      Join now
                    </button>
                  </div>
                </div>
                <div className="fec-room-row">
                  <div className="fec-room-row__left">
                    <div className="fec-room-emoji-box" aria-hidden>
                      🧪
                    </div>
                    <div>
                      <div className="fec-room-card__title">Beta day</div>
                      <div className="fec-room-card__sub">Waiting together · same-day nerves · no spoilers</div>
                    </div>
                  </div>
                  <div className="fec-room-row__right">
                    <span className="fec-count-text">
                      <span className="fec-count-dot" aria-hidden="true" />
                      5 in room
                    </span>
                    <button type="button" className="fec-join-now" onClick={go}>
                      Join now
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="fec-live-rooms-grid__col">
              <div className="fec-live-rooms-grid__head">
                <div className="fec-live-rooms-grid__title">Your local chapter</div>
                <div className="fec-live-rooms-grid__meta">
                  Same city, same clinics, same drive home. Local rooms grow as your community does.
                </div>
              </div>
              <div className="fec-discover-rooms">
                <div className="fec-room-row">
                  <div className="fec-room-row__left">
                    <div className="fec-room-emoji-box" aria-hidden>
                      🌸
                    </div>
                    <div>
                      <div className="fec-room-card__title">Columbus fertility chat</div>
                      <div className="fec-room-card__sub">
                        Ohio Fertility Network · local clinic recs · monitoring tips
                      </div>
                    </div>
                  </div>
                  <div className="fec-room-row__right">
                    <span className="fec-count-text">
                      <span className="fec-count-dot" aria-hidden="true" />
                      6 online
                    </span>
                    <button type="button" className="fec-join-now" onClick={go}>
                      Join now
                    </button>
                  </div>
                </div>
                <div className="fec-room-row">
                  <div className="fec-room-row__left">
                    <div className="fec-room-emoji-box" aria-hidden>
                      🌸
                    </div>
                    <div>
                      <div className="fec-room-card__title">Columbus IVF support circle</div>
                      <div className="fec-room-card__sub">Shared cycles, local retrievals, central Ohio RE community</div>
                    </div>
                  </div>
                  <div className="fec-room-row__right">
                    <span className="fec-count-text">
                      <span className="fec-count-dot" aria-hidden="true" />
                      4 online
                    </span>
                    <button type="button" className="fec-join-now" onClick={go}>
                      Join now
                    </button>
                  </div>
                </div>
                <div className="fec-room-row">
                  <div className="fec-room-row__left">
                    <div className="fec-room-emoji-box" aria-hidden>
                      🌸
                    </div>
                    <div>
                      <div className="fec-room-card__title">Columbus recurrent loss support</div>
                      <div className="fec-room-card__sub">
                        RPL peers · Ohio Fertility Network area · navigating loss in central Ohio together
                      </div>
                    </div>
                  </div>
                  <div className="fec-room-row__right">
                    <span className="fec-count-text">
                      <span className="fec-count-dot" aria-hidden="true" />
                      3 online
                    </span>
                    <button type="button" className="fec-join-now" onClick={go}>
                      Join now
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="fec-live-rooms-grid__col">
              <div className="fec-live-rooms-grid__head">
                <div className="fec-live-rooms-grid__title">Expert-led sessions</div>
                <div className="fec-live-rooms-grid__meta">
                  Facilitated rooms with a nurse or counselor. Capped at 20 women.
                </div>
              </div>
              <div className="fec-discover-rooms">
                <div className="fec-room-row fec-room-row--scheduled">
                  <div className="fec-room-row__left">
                    <div className="fec-room-emoji-box" aria-hidden>
                      🌙
                    </div>
                    <div>
                      <div className="fec-room-card__title">Night before retrieval · Tonight 8pm EST</div>
                      <div className="fec-room-card__sub">IVF anxiety · nurse facilitated · 14 of 20 spots filled</div>
                    </div>
                  </div>
                  <div className="fec-room-row__right fec-room-row__right--scheduled">
                    <button type="button" className="fec-join-now" onClick={go}>
                      Register
                    </button>
                  </div>
                </div>
                <div className="fec-room-row fec-room-row--scheduled">
                  <div className="fec-room-row__left">
                    <div className="fec-room-emoji-box" aria-hidden>
                      💗
                    </div>
                    <div>
                      <div className="fec-room-card__title">Starting again after a failed cycle · Tomorrow 7am EST</div>
                      <div className="fec-room-card__sub">After loss · hosted · 22 registered</div>
                    </div>
                  </div>
                  <div className="fec-room-row__right fec-room-row__right--scheduled">
                    <button type="button" className="fec-join-now" onClick={go}>
                      Register
                    </button>
                  </div>
                </div>
                <div className="fec-room-row fec-room-row--scheduled">
                  <div className="fec-room-row__left">
                    <div className="fec-room-emoji-box" aria-hidden>
                      🧬
                    </div>
                    <div>
                      <div className="fec-room-card__title">Low AMH — what the research shows · Fri 12pm EST</div>
                      <div className="fec-room-card__sub">RE Q&amp;A live · 8 of 20 spots left</div>
                    </div>
                  </div>
                  <div className="fec-room-row__right fec-room-row__right--scheduled">
                    <button type="button" className="fec-join-now" onClick={go}>
                      Register
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export function FertilityCommunitySpacesTab({ navigate }) {
  const go = () => navigate('/signup');

  return (
    <div className="fec-connect-root chapter-fertility">
      <div className="fec-connect-discover">
        <section className="fec-connect-section fec-connect-section--discover">
          <DiscoverHeader
            eyebrow="Nova Spaces"
            title="Spaces for every stage"
            sub="Nova matched you to these groups based on your cycle, protocol, and stage."
            onSeeAll={go}
          />
          <div className="fec-discover-spaces">
            <div className="fec-ns-group-row">
              <div className="fec-room-emoji-box" aria-hidden>
                🌸
              </div>
              <div className="fec-ns-group-row__text">
                <div className="fec-ns-group-name">IVF Warriors — Cycle 1</div>
                <div className="fec-ns-group-sub">3,240 members · your cycle · Nova active in every thread</div>
              </div>
              <span className="fec-ns-group-status fec-ns-group-status--joined">Joined</span>
            </div>
            <div className="fec-ns-group-row">
              <div className="fec-room-emoji-box" aria-hidden>
                💛
              </div>
              <div className="fec-ns-group-row__text">
                <div className="fec-ns-group-name">Low AMH Warriors</div>
                <div className="fec-ns-group-sub">2,100 members · Nova matched you · thread active now</div>
              </div>
              <button type="button" className="fec-ns-group-status fec-ns-group-status--join" onClick={go}>
                Join
              </button>
            </div>
            <div className="fec-ns-group-row">
              <div className="fec-room-emoji-box" aria-hidden>
                🌙
              </div>
              <div className="fec-ns-group-row__text">
                <div className="fec-ns-group-name">PCOS Sisters</div>
                <div className="fec-ns-group-sub">4,100 members · Nova matched you</div>
              </div>
              <button type="button" className="fec-ns-group-status fec-ns-group-status--join" onClick={go}>
                Join
              </button>
            </div>
            <div className="fec-ns-group-row">
              <div className="fec-room-emoji-box" aria-hidden>
                📍
              </div>
              <div className="fec-ns-group-row__text">
                <div className="fec-ns-group-name">Columbus, OH fertility chat</div>
                <div className="fec-ns-group-sub">618 members · near you</div>
              </div>
              <button type="button" className="fec-ns-group-status fec-ns-group-status--join" onClick={go}>
                Join
              </button>
            </div>
            <div className="fec-ns-group-row">
              <div className="fec-room-emoji-box" aria-hidden>
                💔
              </div>
              <div className="fec-ns-group-row__text">
                <div className="fec-ns-group-name">After loss — trying again</div>
                <div className="fec-ns-group-sub">2,870 members · recurrent loss · RPL · healing</div>
              </div>
              <button type="button" className="fec-ns-group-status fec-ns-group-status--join" onClick={go}>
                Join
              </button>
            </div>
            <div className="fec-ns-group-row">
              <div className="fec-room-emoji-box" aria-hidden>
                ⏳
              </div>
              <div className="fec-ns-group-row__text">
                <div className="fec-ns-group-name">Two-week wait &amp; beta buddies</div>
                <div className="fec-ns-group-sub">5,620 members · symptom spirals · testing day</div>
              </div>
              <button type="button" className="fec-ns-group-status fec-ns-group-status--join" onClick={go}>
                Join
              </button>
            </div>
            <div className="fec-ns-group-row">
              <div className="fec-room-emoji-box" aria-hidden>
                💉
              </div>
              <div className="fec-ns-group-row__text">
                <div className="fec-ns-group-name">Medicated cycle support</div>
                <div className="fec-ns-group-sub">1,940 members · IUI · letrozole · injectables</div>
              </div>
              <button type="button" className="fec-ns-group-status fec-ns-group-status--join" onClick={go}>
                Join
              </button>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
